import { Component, Input } from '@angular/core';

@Component({
  selector: 'c-spinner',
  standalone: false,
  template: `
    @if (loading) {
      <ion-spinner [color]="color" name="crescent"></ion-spinner>
    }
  `,
})
export class SpinnerComponent {
  @Input() loading: boolean;
  @Input() color: 'primary' | 'secondary' | 'medium' |'light' | undefined = 'primary';
}
